import SiteMixins from "../mixins/SiteMixins";
import CONST from '@tutils/Constants';

export default {
  computed: {},
  mixins: [SiteMixins],
  methods: {
    getProductImage(product, format) {
      if (!!product && !!product.images && !!format) {
        return product.images.find(image => format === image.format);
      }
      return {
        "imageType": "PRIMARY",
        "format": format,
        "url": ACC.config.themeResourcePath.concat('/images/noimage-thumb.jpg'),
        "altText": "EMPTY_IMG",
        "galleryIndex": null
      };
    },
    getProductDescription(product) {
      return !!product.sku ? product.sku : product.cod1.concat("-").concat(product.cod2).concat("/").concat(product.cod3);
    },
    onlyNumber($event,value) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

      if ((keyCode === 44 && value.indexOf('.') !== -1) || (keyCode === 46 && value.indexOf(',') !== -1)) { // 46 is dot 44 is comma
        $event.preventDefault();
      }

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || value.indexOf('.') !== -1) && (keyCode !== 44 || value.indexOf(',') !== -1)) { // 46 is dot 44 is comma
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (value != null && ((value.indexOf(".") > -1 && (value.split('.')[1].length > 1)) || value.indexOf(",") > -1 && (value.split(',')[1].length > 1))) {
        $event.preventDefault();
      }
    },
    getProductHeight(productClassification, division) {
      if (productClassification && division) {
        let classificationWidth = productClassification.find(classification => CONST.CLASSIFICATION[division].HEIGHT === classification.code);
        if (classificationWidth) {
          let feature = classificationWidth.features[0];
          return {"label": feature.name, "value": feature.featureValues[0].value, "unitOfMeasure": feature.featureUnit.symbol};
        }
      }
      return null;
    },
    getProductWeight(productClassification, division) {
      if (productClassification && division) {
        let classification = productClassification.find(classification => CONST.CLASSIFICATION[division].WEIGHT === classification.code);
        if (classification) {
          let feature = classification.features[0];
          return {"label": feature.name, "value": feature.featureValues[0].value, "unitOfMeasure": feature.featureUnit.symbol};
        }
      }
      return null;
    },
    getProductMinHeight(productClassification, division) {
      if (productClassification && division) {
        let classificationWidth = productClassification.find(classification => CONST.CLASSIFICATION[division].MIN_HEIGHT === classification.code);
        if (classificationWidth) {
          let feature = classificationWidth.features[0];
          return {"label": feature.name, "value": feature.featureValues[0].value, "unitOfMeasure": feature.featureUnit.symbol};
        }
      }
      return null;
    },
    getCategory(categoryCode, collectionMap) {
      if (collectionMap) {
        let season = collectionMap.season;
        if (collectionMap.season !== "") {
          season = collectionMap.season + "-";
        }
        return season + collectionMap.service + "-" + collectionMap.collection + "-" + collectionMap.division + "-" + collectionMap.society;
      } else if (categoryCode) {
        return categoryCode;
      }
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/global/mixins/ProductMixins.js